import { Component, OnInit } from '@angular/core';
import { GenericDocContainerModel, InventoryTransactionLineService, Pagination } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../../visa';
import { SubSink } from 'subsink2';
import { Subject, } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { InvViewColumn1ViewModelActions } from '../../../generic-doc-view-model-controller/generic-doc-inv-view-model-controller/actions';
import { InvViewColumn1ViewSelectors } from '../../../generic-doc-view-model-controller/generic-doc-inv-view-model-controller/selectors';
import { InvViewColumnViewModelStates } from '../../../generic-doc-view-model-controller/generic-doc-inv-view-model-controller/states';
import { GridOptions } from 'ag-grid-enterprise';
import { SessionActions } from "../../../modules/session/session-controller/actions";
import { SessionSelectors } from '../../../modules/session/session-controller/selectors';
import { SessionStates } from '../../../modules/session/session-controller/states';
import { Store } from '@ngrx/store';
import { SharedUtilitiesHelperFunctions } from '../../helper-functions';

@Component({
  selector: 'app-inv-txn',
  templateUrl: './inv-txn.component.html',
  styleUrls: ['./inv-txn.component.css']
})
export class InvTxnComponent implements OnInit {

  protected subs = new SubSink();
  private columnMoveSubject: Subject<void> = new Subject<void>();
  private debounceTimeMs = 500;

  gridApi;
  gridColumnApi;
  rowData: [];
  gridOptions:GridOptions = {
    statusBar: {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', key: 'totalAndFilter', align: 'left' },
      ]
    },
    defaultColDef: {
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: { suppressFilterButton: true },
      minWidth: 100,
      flex: 1,
      sortable: true,
      resizable: true,
      //suppressCsvExport: true,
      floatingFilter: true
    },
    pagination: true
  }

  columnsDefs = [
    { headerName: 'Item Code', field: 'bl_inv_txn_line.item_code', cellStyle: () => ({ 'text-align': 'left' }) },
    { headerName: 'Item Name', field: 'bl_inv_txn_line.item_name', cellStyle: () => ({ 'text-align': 'left' }) },
    { headerName: 'Description', field: 'bl_inv_txn_line.item_descr', cellStyle: () => ({ 'text-align': 'left' }) },
    {
      headerName: 'Txn Date', field: 'bl_inv_txn_line.txn_date', cellStyle: () => ({ 'text-align': 'left' }),
      valueFormatter: params => params.value ? SharedUtilitiesHelperFunctions.dateFormatter(params.value, 'YYYY-MM-DD') : '',
    },
    {
      headerName: 'Qty Signum', field: 'bl_inv_txn_line.quantity_signum', type: 'numericColumn',
      valueFormatter: params => params.value?.toFixed(0)
    },
    {
      headerName: 'Qty Base', field: 'bl_inv_txn_line.quantity_base', type: 'numericColumn',
      valueFormatter: params => params.value?.toFixed(0)
    },
  ];

  constructor(
    public readonly viewModelStore: Store<InvViewColumnViewModelStates>,
    protected readonly sessionStore: Store<SessionStates>,
    protected invTxnLineService: InventoryTransactionLineService
  ) {}

  ngOnInit() {
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.closeToolPanel();
  }

  createData(genericDoc: GenericDocContainerModel) {
    console.log("on create data....");

    const guids = [...new Set(
      genericDoc.bl_fi_generic_doc_line
        .filter(o => o.txn_type === 'PNS')
        .map(line => line.guid))];
    if(guids){
      const pagination = new Pagination();
      pagination.conditionalCriteria.push({
        columnName: 'guids_generic_doc_line',
        operator: '=',
        value: guids.toString()
      });

      pagination.conditionalCriteria.push({
        columnName: 'calcTotalRecords',
        operator: '=',
        value: 'false'
      });

      this.subs.sink = this.invTxnLineService.getByCriteria(pagination, AppConfig.apiVisa).pipe(
      ).subscribe(resp => {
        this.gridApi.setRowData(resp.data);
      }, err => {
        console.log(err);
      });
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  
  saveColumnStateToLocal(columnApi) {
    const columnState = columnApi.getColumnState();
    const serializedColumnState = JSON.stringify(columnState);
    this.viewModelStore.dispatch(InvViewColumn1ViewModelActions.setGenericDocInvListing_State({genericDocInvListingState:serializedColumnState}))
  }
  ngAfterViewInit() {
    // Listen for column movement and debounce the action dispatch
    this.subs.add(
      this.columnMoveSubject
        .pipe(debounceTime(this.debounceTimeMs))
        .subscribe(() => {
          this.saveColumnStateToLocal(this.gridOptions.columnApi);
          this.saveColumnStateToBackend(this.gridOptions.columnApi);
        })
    );
    
    this.subs.sink = this.viewModelStore
      .select(InvViewColumn1ViewSelectors.selectGenericDocInvListing_State)
      .subscribe((data) => {
        if (!data) {
          this.subs.sink = this.sessionStore
            .select(SessionSelectors.selectPersonalSettings)
            .subscribe((data) => {
              if (data.genericDocInvListingState) {
                console.log("data",data.genericDocInvListingState);
                this.viewModelStore.dispatch(
                  InvViewColumn1ViewModelActions.setGenericDocInvListing_State({
                    genericDocInvListingState: data.genericDocInvListingState,
                  })
                );
              }
            });
        }
      });
    
    setTimeout(()=>{
      let serializedColumnState;
      this.subs.sink = this.viewModelStore.select(InvViewColumn1ViewSelectors.selectGenericDocInvListing_State).subscribe(data=>{
        if(data){
          serializedColumnState=data;
        }
      })
      if (serializedColumnState) {
        const newColumnState = JSON.parse(serializedColumnState);
        const currentColumnState = this.gridOptions.columnApi.getColumnState();
        const currentColumnIds = new Set(currentColumnState.map(column => column.colId));
      
        const hiddenColumns = {};
          currentColumnState.forEach(column => {
            if (column.hide) {
              hiddenColumns[column.colId] = true;
            }
          });
        const filteredNewColumnState = newColumnState.filter(column => currentColumnIds.has(column.colId));
        const combinedColumnState = filteredNewColumnState.map(column => {
            if (hiddenColumns[column.colId] !== undefined) {
              column.hide = hiddenColumns[column.colId];
            }
            return column;
          });
          this.gridOptions.columnApi.applyColumnState({
            state: combinedColumnState,
            applyOrder: true, // Set this to true to forcefully apply the state
          });
          console.log('Column State Applied:', combinedColumnState);
      }
    
    },2000);
    
   
    
  }
  
  // Define a function to save column state to the backend
  saveColumnStateToBackend(columnApi) {
    const columnState = columnApi.getColumnState();
    const serializedColumnState = JSON.stringify(columnState);
    this.sessionStore.dispatch(SessionActions.saveColumnStateInit({ settings: {genericDocInvListingState:serializedColumnState} }));
   }
  ngAfterViewChecked() {
    // Listen for column visibility changes
    this.gridOptions.api.addEventListener("columnVisible", (event) => {
      this.columnMoveSubject.next();
    });
    // Listen for column movement
    this.gridOptions.api.addEventListener("columnMoved", (event) => {
      this.columnMoveSubject.next();
    });
  }

}
